<div class="mt-4 wrapper-content">
  <div class="col-12 mb-4">
    <p-card styleClass="shadow-3">
      <div class="p-0">
        <a [routerLink]="'/'+basePath" class="text-blue-general inline-flex align-items-center no-underline">
          <i class="pi pi-arrow-left mr-2"></i>
          <p>{{translations.volver}}</p>
        </a>

        <!-- Encabezado del formulario -->
        <div class="text-left mb-4 ">
          <h1 class="font-23 text-black  mb-2">{{ translations.titulo }}</h1>
            <h2 class="font-18 text-blue-general">{{ translations.subtitulo }}</h2>
        </div>

        <form [formGroup]="formularioPqrsdf">
          <!-- Sección de Información Personal -->
          <div class="mb-4">
            <h3 class="text-lg font-medium mb-3">{{translations.seccionInfoPersonal}}</h3>
            <p-divider></p-divider>

            <!-- Tipo de Persona -->
            <div class="field mb-4">
              <label class="block mb-2 font-medium color-form-label">{{ translations.tipoPersona }}
                <span class="text-red-500">*</span>
              </label>
              <div class="flex flex-wrap gap-4">
                <div *ngFor="let tipo of tiposPersona" class="flex align-items-center">
                  <p-radioButton [inputId]="'tipo_' + tipo.id"
                                 [value]="tipo.id" formControlName="tipoPersona"></p-radioButton>
                  <label [for]="'tipo_' + tipo.id" class="ml-2 color-form-label">{{ tipo.descripcion }}</label>
                </div>
              </div>
            </div>

            <div class="grid formgrid">
              <!-- Primera columna -->
              @if (!isAnonimo) {

                <div class="col-12 md:col-6 field mb-4">
                  <label class="block mb-2 font-medium color-form-label">{{ translations.tipoIdentificacion }}
                    <span class="text-red-500">*</span>
                  </label>
                  <p-dropdown [options]="_tiposIdentificacion" formControlName="identificacion"
                              [placeholder]="translations.tipoIdentificacionPlaceholder" optionLabel="abreviatura"
                              styleClass="w-full"></p-dropdown>
                  <ng-container
                    *ngIf="formularioPqrsdf.get('identificacion')?.invalid && formularioPqrsdf.get('identificacion')?.touched">
                    <app-form-group-error-message [control]="formularioPqrsdf.get('identificacion')"/>
                  </ng-container>
                </div>

                <div class="col-12 md:col-6 field mb-4">
                  <label class="block mb-2 font-medium color-form-label">{{ translations.numeroIdentificacion }}
                    <span class="text-red-500">*</span>
                  </label>
                  <p-inputNumber formControlName="numeroIdentificacion"
                                 styleClass="w-full" class="w-full" [useGrouping]="false"></p-inputNumber>
                  <ng-container
                    *ngIf="formularioPqrsdf.get('numeroIdentificacion')?.invalid && formularioPqrsdf.get('numeroIdentificacion')?.touched">
                    <app-form-group-error-message [control]="formularioPqrsdf.get('numeroIdentificacion')"/>
                  </ng-container>
                </div>

                <div class="col-12 md:col-6 field mb-4" *ngIf="formularioPqrsdf.get('tipoPersona')?.value === JURIDICA">
                  <label class="block mb-2 font-medium color-form-label">{{translations.razonSocial}}
                    <span class="text-red-500">*</span>
                  </label>
                  <input pInputText type="text" formControlName="razonSocial"
                         class="w-full">
                  <ng-container
                    *ngIf="formularioPqrsdf.get('razonSocial')?.invalid && formularioPqrsdf.get('razonSocial')?.touched">
                    <app-form-group-error-message [control]="formularioPqrsdf.get('razonSocial')"/>
                  </ng-container>
                </div>

                @if (tipoPersona != JURIDICA) {
                  <div class="col-12 md:col-6 field mb-4">
                    <label class="block mb-2 font-medium color-form-label">{{translations.primerNombre}}
                      <span class="text-red-500">*</span>
                    </label>
                    <input pInputText type="text" formControlName="primerNombre"
                           class="w-full">
                    <ng-container
                      *ngIf="formularioPqrsdf.get('primerNombre')?.invalid && formularioPqrsdf.get('primerNombre')?.touched">
                      <app-form-group-error-message [control]="formularioPqrsdf.get('primerNombre')"/>
                    </ng-container>
                  </div>
                  <div class="col-12 md:col-6 field mb-4">
                    <label class="block mb-2 font-medium color-form-label">{{translations.segundoNombre}}</label>
                    <input pInputText type="text" formControlName="segundoNombre"
                           class="w-full">
                  </div>
                  <div class="col-12 md:col-6 field mb-4">
                    <label class="block mb-2 font-medium color-form-label">{{ translations.primerApellido }}
                      <span class="text-red-500">*</span>
                    </label>
                    <input pInputText type="text" formControlName="primerApellido"
                           class="w-full">
                    <ng-container
                      *ngIf="formularioPqrsdf.get('primerApellido')?.invalid && formularioPqrsdf.get('primerApellido')?.touched">
                      <app-form-group-error-message [control]="formularioPqrsdf.get('primerApellido')"/>
                    </ng-container>
                  </div>
                  <div class="col-12 md:col-6 field mb-4">
                    <label class="block mb-2 font-medium color-form-label">{{translations.segundoApellido }}</label>
                    <input pInputText type="text" formControlName="segundoApellido"
                           class="w-full">
                  </div>
                }
              }
              <div class="col-12 md:col-6 field mb-4">
                <label class="block mb-2 font-medium color-form-label"> {{translations.pais}}
                  <span class="text-red-500">*</span>
                </label>
                <p-dropdown [options]="paises" formControlName="pais" [placeholder]="translations.paisPlaceholder"
                            filterBy="descripcion" [filter]="true" [resetFilterOnHide]="true" optionValue="id"
                            (onChange)="onchangePais($event.value)" optionLabel="descripcion"
                            styleClass="w-full"></p-dropdown>
                <ng-container
                  *ngIf="formularioPqrsdf.get('pais')?.invalid && formularioPqrsdf.get('pais')?.touched">
                  <app-form-group-error-message [control]="formularioPqrsdf.get('pais')"/>
                </ng-container>
              </div>
              @if (!isAnonimo) {
                <div class="col-12 md:col-6 field mb-4">
                  <label class="block mb-2 font-medium color-form-label">{{ translations.departamento }}
                    <span class="text-red-500">*</span>
                  </label>
                  <p-dropdown [options]="departamentos" formControlName="departamento" optionLabel="descripcion"
                              filterBy="descripcion" (onChange)="onChangeDepartamento($event.value)"
                              [placeholder]="translations.deparamentoPlaceholder" [filter]="true"
                              [resetFilterOnHide]="true"
                              styleClass="w-full"></p-dropdown>
                  <ng-container
                    *ngIf="formularioPqrsdf.get('departamento')?.invalid && formularioPqrsdf.get('departamento')?.touched">
                    <app-form-group-error-message [control]="formularioPqrsdf.get('departamento')"/>
                  </ng-container>
                </div>

                <div class="col-12 md:col-6 field mb-4">
                  <label class="block mb-2 font-medium color-form-label">{{ translations.municipio }}
                    <span class="text-red-500" *ngIf="!isOtroDepartamento">*</span>
                  </label>
                  <p-dropdown [options]="municipios" formControlName="municipio"
                              optionValue="id" optionLabel="descripcion" [filter]="true" [resetFilterOnHide]="true"
                              [placeholder]="translations.municipioPlaceholder" filterBy="descripcion"
                              styleClass="w-full"></p-dropdown>
                  <ng-container
                    *ngIf="formularioPqrsdf.get('municipio')?.invalid && formularioPqrsdf.get('municipio')?.touched">
                    <app-form-group-error-message [control]="formularioPqrsdf.get('municipio')"/>
                  </ng-container>
                </div>

                <div class="col-12 md:col-6 field mb-4">
                  <label class="block mb-2 font-medium color-form-label">{{translations.tipoPoblacion}}
                    <span class="text-red-500">*</span>
                  </label>
                  <p-dropdown [options]="tiposPoblacion" formControlName="tipoPoblacion"
                              [placeholder]="translations.tipoPoblacionPlaceholder" optionLabel="descripcion"
                              styleClass="w-full"></p-dropdown>
                </div>

                <div class="col-12 md:col-6 field mb-4">
                  <label class="block mb-2 font-medium color-form-label">{{ translations.direccion }}
                    <span class="text-red-500">*</span>
                  </label>
                  <input pInputText type="text" formControlName="direccion" (click)="openDireccion = true"
                         (keyup.enter)="openDireccion = true" readonly class="w-full">
                  <ng-container
                    *ngIf="formularioPqrsdf.get('direccion')?.invalid && formularioPqrsdf.get('direccion')?.touched">
                    <app-form-group-error-message [control]="formularioPqrsdf.get('direccion')"/>
                  </ng-container>
                </div>

                <div class="col-12 md:col-6 field mb-4">
                  <label class="block mb-2 font-medium color-form-label">{{ translations.telefono }}
                    <span class="text-red-500">*</span>
                  </label>
                  <input pInputText type="text" formControlName="telefono"
                         class="w-full">
                  <ng-container
                    *ngIf="formularioPqrsdf.get('telefono')?.invalid && formularioPqrsdf.get('telefono')?.touched">
                    <app-form-group-error-message [control]="formularioPqrsdf.get('telefono')"/>
                  </ng-container>
                </div>

                <div class="col-12 md:col-6 field mb-4">
                  <label class="block mb-2 font-medium color-form-label">
                    {{ translations.presentaDiscapacidad }}
                  </label>
                  <p-dropdown [options]="opcionesSiNo" formControlName="presentaDiscapacidad"
                              [placeholder]="translations.presentaDiscapacidadPlaceholder" styleClass="w-full"></p-dropdown>
                </div>

                <div class="col-12 md:col-6 field mb-4">
                  <label class="block mb-2 font-medium color-form-label">{{ translations.discapacidad }}</label>
                  <p-dropdown [options]="tiposDiscapacidad" formControlName="discapacidad"
                              [placeholder]="translations.discapacidadPlaceholder"
                              optionLabel="descripcion" optionValue="id"
                              styleClass="w-full"></p-dropdown>
                  <ng-container
                    *ngIf="formularioPqrsdf.get('discapacidad')?.invalid && formularioPqrsdf.get('discapacidad')?.touched">
                    <app-form-group-error-message [control]="formularioPqrsdf.get('discapacidad')"/>
                  </ng-container>
                </div>
              }
              <div class="col-12 md:col-6 field mb-4">
                <label class="block mb-2 font-medium color-form-label">{{ translations.correo }}
                  <span class="text-red-500">*</span>
                </label>
                <input pInputText type="email" formControlName="correoElectronico"
                       class="w-full">
                <ng-container
                  *ngIf="formularioPqrsdf.get('correoElectronico')?.invalid && formularioPqrsdf.get('correoElectronico')?.touched">
                  <app-form-group-error-message [control]="formularioPqrsdf.get('correoElectronico')"/>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Sección de Detalle de la Solicitud -->
          <div class="mt-4">
            <h3 class="text-lg font-medium mb-3">{{ translations.seccionInfoSolicitud }}</h3>
            <p-divider></p-divider>

            <div class="grid formgrid">
              <div class="col-12 md:col-6 field mb-4">
                <label class="block mb-2 font-medium color-form-label">{{translations.tipoSolicitud}}
                  <span class="text-red-500">*</span>
                </label>
                <p-dropdown [options]="tiposSolicitud"
                            formControlName="tipoSolicitud" [placeholder]="translations.tipoSolicitudPlaceholder"
                            optionValue="id" optionLabel="descripcion" styleClass="w-full"></p-dropdown>
                <ng-container
                  *ngIf="formularioPqrsdf.get('tipoSolicitud')?.invalid && formularioPqrsdf.get('tipoSolicitud')?.touched">
                  <app-form-group-error-message [control]="formularioPqrsdf.get('tipoSolicitud')"/>
                </ng-container>
              </div>
              <div class="col-12 md:col-6 field mb-4">
                <label class="block mb-2 font-medium color-form-label"> {{translations.tramite}} </label>
                <p-dropdown [options]="tiposTramites"
                            formControlName="tramite" [placeholder]="translations.tipoTramitePlaceholder"
                            optionLabel="tramiteDescripcion" styleClass="w-full"></p-dropdown>
              </div>

              <div class="col-12 md:col-6 field mb-4">
                <label class="block mb-2 font-medium color-form-label">{{translations.temaSolicitud}}
                  <span class="text-red-500">*</span>
                </label>
                <input pInputText type="text" formControlName="temaSolicitud" class="w-full">
                <ng-container
                  *ngIf="formularioPqrsdf.get('temaSolicitud')?.invalid && formularioPqrsdf.get('temaSolicitud')?.touched">
                  <app-form-group-error-message [control]="formularioPqrsdf.get('temaSolicitud')"/>
                </ng-container>
              </div>

              <div class="col-12 field mb-4">
                <label class="block mb-2 font-medium color-form-label">{{ translations.descripcionSolicitud }}
                  <span class="text-red-500">*</span>
                </label>
                <textarea pInputTextarea formControlName="descripcionSolicitud" rows="5" class="w-full"></textarea>
                <ng-container
                  *ngIf="formularioPqrsdf.get('descripcionSolicitud')?.invalid && formularioPqrsdf.get('descripcionSolicitud')?.touched">
                  <app-form-group-error-message [control]="formularioPqrsdf.get('descripcionSolicitud')"/>
                </ng-container>
              </div>
              <div class="col-12">
                <div class="flex">
                  <p-fileUpload #fileUpload mode="basic"
                                accept="application/pdf" [maxFileSize]="uploadFileSize"
                                [chooseLabel]="'form.button.agregar-documento' | translate"
                                [customUpload]="true" [auto]="true" chooseIcon="pi pi-upload"
                                (uploadHandler)="uploadHandler($event, fileUpload)"></p-fileUpload>
                  <button pButton icon="pi pi-trash" class="p-button-cancel-fileupload cancel border-noround-left	" (click)="removeFile()"
                          [disabled]="!adjunto"></button>
                </div>

                @if (invalidSize) {
                  <small class="p-error block">
                    <strong>{{ adjunto?.name }}</strong>: {{ "form.msg.invalid-size" | translate }} </small>
                } @else if (adjunto?.size && !invalidSize) {
                  <small class="text-gray-700 block"> {{ adjunto?.name }} </small>
                }
              </div>
            </div>
          </div>

          <div class="mt-5">
            <h3 class="text-lg font-medium mb-3"> {{translations.seccionRecepcionRespuesta}}</h3>
            <p-divider></p-divider>
            <div class="grid formgrid">
              <div class="col-12 md:col-6 field mb-4">
                <label class="block mb-2 font-medium color-form-label">{{ translations.medioRecepcion }}
                  <span class="text-red-500">*</span>
                </label>
                <p-dropdown [options]="mediosRecepcion" formControlName="medioRecepcion"
                            [placeholder]="translations.medioRecepcionPlaceholder"
                            optionLabel="descripcion" optionValue="id"
                            (onChange)="changeMedioRecepcion($event.value)"
                            styleClass="w-full"></p-dropdown>
                <ng-container
                  *ngIf="formularioPqrsdf.get('medioRecepcion')?.invalid && formularioPqrsdf.get('medioRecepcion')?.touched">
                  <app-form-group-error-message [control]="formularioPqrsdf.get('medioRecepcion')"/>
                </ng-container>
              </div>

              <div class="col-12 md:col-6 field mb-4">
                <label class="block mb-2 font-medium color-form-label">{{ labelNotificacion }}
                  <span class="text-red-500">*</span>
                </label>
                <input pInputText type="text" formControlName="notificacion"
                       class="w-full">
                <ng-container
                  *ngIf="formularioPqrsdf.get('notificacion')?.invalid && formularioPqrsdf.get('notificacion')?.touched">
                  <app-form-group-error-message [control]="formularioPqrsdf.get('notificacion')"/>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="col-12 my-4 flex align-items-center gap-3 cursor-pointer">
            <p-checkbox formControlName="politicaDatos"
                        [binary]="true" inputId="politicaDatos"/>
            <label for="politicaDatos">
              {{ translations.estoyDeAcuerdo }}
              <a routerLink="/public/politica-datos" target="_blank"
                 class="text-blue-general cursor-pointer">
                {{ translations.politicaDatos }}
              </a>.
            </label>

          </div>

          <div class="col-12 flex justify-content-center align-items-center" *ngIf="!recaptchaIgnore">
            <re-captcha formControlName="recaptchaReactive"/>
          </div>

          <!-- Botones de acción -->
          <div class="flex justify-content-end mt-4">
            <button pButton [label]="translations.buttonLimpiar" class="p-button-outlined p-button-secondary mr-2"
                    (click)="resetForm()"></button>
            <button pButton [label]="translations.buttonAceptar" (click)="enviarFormulario()"
                     ></button>
          </div>
        </form>
      </div>
    </p-card>
  </div>
</div>

<direcciones [(visible)]="openDireccion"
             (direccionResult)="changeDireccion($event)"/>
